"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HtmlUtilities_1 = require("./HtmlUtilities");
var models_1 = require("../models");
var JobRequisitionShareLinkGetter = (function () {
    function JobRequisitionShareLinkGetter() {
    }
    JobRequisitionShareLinkGetter.prototype.getFacebookShareUrl = function (appID, jobAdUrl, redirectBaseUrl) {
        var encodedRedirectUrl = encodeURIComponent(redirectBaseUrl + "EPM/CareerCenter/FacebookRedirectLanding.aspx");
        var encodedJobAdUrl = encodeURIComponent(jobAdUrl);
        return "https://www.facebook.com/dialog/feed?app_id=" + appID + "&link=" + encodedJobAdUrl + "&redirect_uri=" + encodedRedirectUrl;
    };
    JobRequisitionShareLinkGetter.prototype.getMailtoURI = function (title, url) {
        title = encodeURIComponent(title);
        url = encodeURIComponent(url);
        return "mailto:?subject=" + title + "&body=" + url;
    };
    JobRequisitionShareLinkGetter.prototype.getLinkedInUri = function (jobDetailsUrl, title, description, userId) {
        var linkedInBaseUrl = "http://www.linkedin.com/shareArticle";
        jobDetailsUrl = jobDetailsUrl + "&m=" + models_1.JobBoard.ReferralLinkedIn;
        if (userId) {
            jobDetailsUrl = jobDetailsUrl + "&u=" + userId;
        }
        var redirectedUrl = linkedInBaseUrl + "?mini=true&url=" + encodeURIComponent(jobDetailsUrl);
        if (title.length > 0) {
            redirectedUrl = redirectedUrl + "&title=" + encodeURIComponent(HtmlUtilities_1.StripHtml(title));
        }
        if (description.length > 0) {
            var trimmedDescription = HtmlUtilities_1.StripHtml(description);
            if (trimmedDescription.length > 256) {
                trimmedDescription = trimmedDescription.substring(0, 252) + "...";
            }
            redirectedUrl = redirectedUrl + "&summary=" + encodeURIComponent(trimmedDescription);
        }
        return redirectedUrl;
    };
    return JobRequisitionShareLinkGetter;
}());
exports.JobRequisitionShareLinkGetter = JobRequisitionShareLinkGetter;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/shared/JobRequisitionShareLinkGetter.ts
// module id = 343
// module chunks = 0